import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginationModule} from 'ngx-bootstrap/pagination';
import { ModalModule} from 'ngx-bootstrap/modal';
import { BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxUiLoaderModule, POSITION, NgxUiLoaderHttpModule } from 'ngx-ui-loader';

import { AppRoutingModule } from './app-routing/app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';

import { AuthInterceptor } from './shared/interceptors/auth-interceptor';
import { HttpTimeoutInterceptor } from './shared/interceptors/timeout.interceptor';
import { MessageService } from './services/message.service';
import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';
import { LookupService } from './services/lookup.service';
import { CompanyService } from './components/company/company.service';
import { AddressBookService } from './components/address-book/address-book.service';
import { ManifestService } from './components/manifest/manifest.service';
import { UserService } from './components/user-profile/user.service';

import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { ChangePwdComponent } from './components/user-profile/change-pwd/change-pwd.component';
import { CreateCompanyProfileComponent } from './components/company-profile/create-company-profile/create-company-profile.component';
import { NavmenuComponent } from './components/home/layout/nav-menu/nav-menu';
import { SidemenuComponent } from './components/home/layout/side-menu/side-menu';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { environment } from 'src/environments/environment';
import { CitFooterComponent } from './components/home/layout/cit-footer/cit-footer.component';
import { GeneralFormComponent } from './shared/components/general-form/general-form.component';
import { SharedComponentModule } from './shared/components/shared-component/shared-component.module';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { RegisterComponent } from './components/register/register.component';
import { Page404Component } from './components/notfound/404-page.componenet';
import { CountDownComponent } from './components/count-down.component';
import { CAPaymentLoadingComponent } from './components/ca-confirm-payment/ca-payment-loading.component';
import { LogoutModalComponent } from './components/logout-modal/logout-modal.component';
import { defineLocale, deLocale } from 'ngx-bootstrap/chronos';

defineLocale('en-gb', deLocale);

@NgModule({
  declarations: [
    NavmenuComponent,
    SidemenuComponent,
    AppComponent,
    LoginComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    FooterComponent,
    HomeComponent,
    Page404Component,
    UserProfileComponent,
    CreateCompanyProfileComponent,
    ChangePwdComponent,
    CitFooterComponent,
    GeneralFormComponent,
    CAPaymentLoadingComponent,
    NotfoundComponent,
    RegisterComponent,
    CountDownComponent,
    LogoutModalComponent
  ],
  imports: [
    BrowserModule,
    SharedComponentModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    PaginationModule.forRoot(),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot(),
    TooltipModule.forRoot(),
    NgxUiLoaderModule.forRoot({
      bgsPosition: POSITION.centerCenter,
      bgsColor: '#007bff',
      bgsType: 'rotating-plane',
      fgsColor: '#007bff',
      fgsType: 'rotating-plane'
    }),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: false,
      exclude: [
        `${environment.baseUrl}/tokenauth/authenticate`,
        `${environment.baseUrl}/tokenauth/refresh`,
        `${environment.baseUrl}/v1/user/me/view`
      ]
    }),
    AlertModule.forRoot()
  ],
  providers: [
    MessageService,
    AuthService,
    AuthGuardService,
    LookupService,
    CompanyService,
    AddressBookService,
    ManifestService,
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTimeoutInterceptor,
      multi: true
    },
    // {provide: BsLocaleService, useValue: 'en-gb', multi: false},
  ],
  entryComponents: [
    LogoutModalComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
